import React, { useEffect, useState } from 'react';
import { Phone, Shield, Clock, Award, Wrench, Droplet, Home as HomeIcon, Building2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import GoogleReviews from '../components/GoogleReviews';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Preload apenas as primeiras 4 fotos (primeira linha visível)
    const preloadImages = galleryImages.slice(0, 4);
    preloadImages.forEach(img => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = img.url;
      document.head.appendChild(link);
    });
  }, []);

  const whatsappNumber = '5515991254009';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  const handleWhatsAppClick = () => {
    // Track WhatsApp click in GTM
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'whatsapp_click',
        'button_location': 'page'
      });
    }
    window.open(whatsappLink, '_blank');
  };

  const services = [
    {
      icon: <Droplet className="w-12 h-12 text-nabson-cyan" />,
      title: 'Fabricação de Calhas',
      description: 'Calhas fabricadas sob medida com materiais premium de alta durabilidade e resistência.'
    },
    {
      icon: <HomeIcon className="w-12 h-12 text-nabson-cyan" />,
      title: 'Instalação de Rufos Metálicos',
      description: 'Instalação técnica de rufos metálicos garantindo proteção total contra infiltrações.'
    },
    {
      icon: <Shield className="w-12 h-12 text-nabson-cyan" />,
      title: 'Aplicação de Pingadeiras',
      description: 'Pingadeiras de precisão para proteção completa de muros e fachadas.'
    },
    {
      icon: <Wrench className="w-12 h-12 text-nabson-cyan" />,
      title: 'Manutenção de Condutores',
      description: 'Manutenção preventiva e corretiva de todo sistema de escoamento pluvial.'
    }
  ];

  const differentials = [
    {
      icon: <Award className="w-16 h-16 text-nabson-cyan" />,
      title: 'Qualidade Premium',
      description: 'Materiais de primeira linha com garantia de durabilidade'
    },
    {
      icon: <Clock className="w-16 h-16 text-nabson-cyan" />,
      title: 'Atendimento Rápido',
      description: 'Resposta ágil e instalação dentro do prazo estabelecido'
    },
    {
      icon: <Shield className="w-16 h-16 text-nabson-cyan" />,
      title: 'Garantia de Vedação',
      description: 'Proteção absoluta contra infiltrações e vazamentos'
    }
  ];

  const galleryImages = [
    // FOTOS NOVAS (mais bonitas) - PRIMEIRO
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/7lqaa7sc_Screenshot_20260607_215511_Gallery.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/52ehr40m_Screenshot_20260607_215821_Gallery.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/b6cv3akb_Screenshot_20260607_215732_Gallery.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/ajo2a4fy_IMG_20260630_120359_%281080_x_1080_pixel%29.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/uq9j55ai_IMG_20260630_120305_%281080_x_1080_pixel%29.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/at2fzb77_IMG_20260630_120239_%281080_x_1080_pixel%29.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/7aq8w2h1_IMG_20260630_120209_%281080_x_1080_pixel%29.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/vmehoo9p_IMG-20240617-WA0055.jpg'
    },
    // Fotos antigas (depois)
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/pfgmynzh_dji_fly_20260331_131138_0005_1774973637133_photo.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/n7v2z83v_dji_fly_20260331_131210_0006_1774973613579_photo.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/84qjhs4f_dji_fly_20260331_131016_0004_1774973640942_photo.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/rdiilsuw_dji_fly_20260323_105910_0004_1774275006979_photo.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/ufvsu4jn_dji_fly_20260323_105806_0002_1774275020905_photo.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/oj60djnv_dji_fly_20260323_105842_0003_1774275014407_photo.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/tyai520x_IMG_20260121_152709266.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/c070f1ty_IMG_20260324_153641208_HDR.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/0aj16c5z_IMG_20260114_141857842.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/a8m6llfa_IMG_20241009_090340060_HDR_4K~2.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/zbeleu8h_IMG-20251228-WA0054.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/qeh5wlm7_IMG_20260324_153706822_HDR.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/dmts2ryu_IMG_20260121_152644719.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/edg03qpb_IMG-20260228-WA0047.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/ovsa28ct_IMG_20260121_153628278.jpg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/kbw23vqn_IMG_20260121_161741904.jpg'
    }
  ];

  // Estado para lightbox
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (imageUrl) => {
    setSelectedImage(imageUrl);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
  };

  const coverageAreas = [
    'Boituva', 'Tatuí', 'Iperó', 'Porto Feliz', 'Itu', 'Cerquilho', 'Sorocaba'
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white shadow-lg z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/iqmkoavy_download__16_-removebg.png"
              alt="Calhas Nabson Logo"
              className="h-14 w-auto"
            />
          </div>
          <Button 
            onClick={handleWhatsAppClick}
            id="whatsapp-btn"
            className="bg-nabson-cyan hover:bg-nabson-cyan-dark text-white font-semibold px-6 py-2 rounded-lg transition-all duration-300 transform hover:scale-105"
          >
            <Phone className="w-4 h-4 mr-2" />
            Contato Rápido
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 43, 74, 0.85), rgba(0, 43, 74, 0.85)), url('https://images.unsplash.com/photo-1770580836737-88e86a973229?w=1920')`
        }}
      >
        <div className={`container mx-auto px-4 py-32 text-center transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Proteção e Estética de<br />Alto Padrão para seu Imóvel
          </h2>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto">
            Especialistas em Calhas, Rufos e Pingadeiras com fabricação própria e instalação de precisão
          </p>
          <Button 
            onClick={handleWhatsAppClick}
            id="whatsapp-btn-hero"
            className="bg-nabson-cyan hover:bg-nabson-cyan-dark text-white font-bold px-8 py-6 text-lg rounded-lg transition-all duration-300 transform hover:scale-110 shadow-2xl"
          >
            Solicitar Orçamento Grátis
          </Button>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-nabson-navy mb-16">
            Diferenciais Calhas Nabson
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {differentials.map((item, index) => (
              <Card 
                key={index} 
                className="border-none shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 bg-white"
              >
                <CardContent className="p-8 text-center">
                  <div className="flex justify-center mb-6">
                    {item.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-nabson-navy mb-4">{item.title}</h3>
                  <p className="text-gray-600 text-lg">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Avaliações Google - Social Proof */}
      <GoogleReviews />

      {/* Serviços */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-nabson-navy mb-4">
            Nossos Serviços
          </h2>
          <p className="text-center text-gray-600 text-lg mb-16 max-w-2xl mx-auto">
            Soluções completas em escoamento de águas pluviais para sua segurança e tranquilidade
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <Card 
                key={index}
                className="border-2 border-gray-100 hover:border-nabson-cyan transition-all duration-300 transform hover:-translate-y-2 bg-white shadow-md hover:shadow-xl"
              >
                <CardContent className="p-6">
                  <div className="mb-4">{service.icon}</div>
                  <h3 className="text-xl font-bold text-nabson-navy mb-3">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Galeria */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-nabson-navy mb-4">
            Projetos Realizados
          </h2>
          <p className="text-center text-gray-600 text-lg mb-16 max-w-2xl mx-auto">
            Confira alguns dos nossos trabalhos com excelência em qualidade e acabamento
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {galleryImages.map((image, index) => (
              <div 
                key={index}
                onClick={() => openLightbox(image.url)}
                className="relative overflow-hidden rounded-lg shadow-lg group cursor-pointer transform transition-all duration-300 hover:scale-105 bg-gray-200"
              >
                {/* Skeleton/Placeholder */}
                <div className="absolute inset-0 bg-gradient-to-br from-gray-200 via-gray-300 to-gray-200 animate-pulse"></div>
                
                <img 
                  src={image.url}
                  alt={`Projeto Calhas Nabson ${index + 1}`}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110 relative z-10"
                  loading="lazy"
                  decoding="async"
                  onLoad={(e) => {
                    e.currentTarget.previousElementSibling?.classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-300 z-20 pointer-events-none"></div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-30 pointer-events-none">
                  <div className="bg-white/90 backdrop-blur-sm rounded-full p-3">
                    <svg className="w-6 h-6 text-nabson-navy" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Lightbox Modal */}
          {lightboxOpen && (
            <div 
              className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center p-4"
              onClick={closeLightbox}
            >
              <button
                onClick={closeLightbox}
                className="absolute top-4 right-4 text-white hover:text-nabson-cyan transition-colors duration-300 z-50"
                aria-label="Fechar"
              >
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              
              {/* Loading spinner for lightbox */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-nabson-cyan"></div>
              </div>
              
              <img 
                src={selectedImage}
                alt="Projeto em tamanho completo"
                className="max-w-full max-h-full object-contain relative z-10"
                onClick={(e) => e.stopPropagation()}
                onLoad={(e) => {
                  e.currentTarget.previousElementSibling?.classList.add('hidden');
                }}
              />
            </div>
          )}
        </div>
      </section>

      {/* Sobre Nós */}
      <section className="py-20 bg-nabson-navy text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-12">Sobre Nós</h2>
            <div className="bg-nabson-navy-dark/50 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-nabson-cyan/20">
              <p className="text-lg leading-relaxed mb-6 text-gray-200">
                A Calhas Nabson nasceu da necessidade de oferecer ao mercado de Boituva e região uma solução definitiva em escoamento de águas pluviais. Especializados na fabricação e instalação de calhas, rufos e pingadeiras, unimos a robustez dos melhores materiais a um design 'Esportivo Dinâmico' que valoriza a estética do seu imóvel.
              </p>
              <p className="text-lg leading-relaxed mb-6 text-gray-200">
                Sob a liderança de Pedro Nabson, nossa missão é entregar mais do que apenas chapas de metal; entregamos tranquilidade e proteção contra infiltrações. Cada projeto é tratado de forma exclusiva, com medições de precisão e instalação técnica que garante durabilidade e vedação absoluta.
              </p>
              <p className="text-lg leading-relaxed text-nabson-cyan-light font-semibold">
                Quando você escolhe a Calhas Nabson, você escolhe o padrão de excelência que sua casa merece.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-nabson-cyan">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Pronto para Proteger seu Imóvel?
          </h2>
          <p className="text-xl text-white mb-8 max-w-2xl mx-auto">
            Entre em contato agora e receba um orçamento personalizado sem compromisso
          </p>
          <Button 
            onClick={handleWhatsAppClick}
            id="whatsapp-btn-cta"
            className="bg-nabson-navy hover:bg-nabson-navy-light text-white font-bold px-10 py-6 text-lg rounded-lg transition-all duration-300 transform hover:scale-110 shadow-2xl"
          >
            <Phone className="w-5 h-5 mr-2" />
            Falar com Especialista
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-nabson-navy text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_nabson-gutters-demo/artifacts/iqmkoavy_download__16_-removebg.png"
                  alt="Calhas Nabson Logo"
                  className="h-20 w-auto"
                />
              </div>
              <p className="text-gray-400">
                Excelência em soluções de escoamento pluvial para Boituva e região.
              </p>
            </div>
            <div>
              <h4 className="text-xl font-bold mb-4 text-nabson-cyan">Áreas de Atendimento</h4>
              <div className="flex flex-wrap gap-2">
                {coverageAreas.map((area, index) => (
                  <span key={index} className="bg-nabson-navy-dark px-3 py-1 rounded-full text-sm">
                    {area}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-xl font-bold mb-4 text-nabson-cyan">Contato</h4>
              <div className="space-y-2">
                <p className="flex items-center text-gray-300">
                  <Phone className="w-4 h-4 mr-2 text-nabson-cyan" />
                  (15) 99125-4009
                </p>
                <p className="text-gray-400 text-sm">
                  Atendimento em toda região de Boituva
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center">
            <p className="text-gray-400">
              &copy; 2025 Calhas Nabson - Todos os direitos reservados | www.calhasnabson.com.br
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <button
        onClick={handleWhatsAppClick}
        id="whatsapp-btn-float"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-110 z-50 animate-pulse"
        aria-label="WhatsApp"
      >
        <Phone className="w-6 h-6" />
      </button>
    </div>
  );
};

export default Home;
